import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay]);

Swiper.use([Navigation]);

const swiperW = new Swiper('.clients__swiper', {
  breakpoints: {
    320:{
      slidesPerView: 1,
    },
    500:{
      slidesPerView: 2,
      spaceBetween: 10,
    },
    750:{
      slidesPerView: 3,
      spaceBetween: 15,
    },
    1000:{
      slidesPerView: 4,
      spaceBetween: 20,
    }
  },

  navigation: {
    nextEl: '.clients__slider-btn--next',
    prevEl: '.clients__slider-btn--prev',
  },
});
